<template>
  <div>
    <section class="grid-stack"></section>
  </div>
</template>

<script>
import GridStack from '../../../node_modules/gridstack/dist/gridstack-h5'
import Widget from '@/components/graphs/Widget';
import Vue from 'vue';


export default {
  props: [
    'items',
    'deleteWidget',
    'filters',
  ],
  data: function () {
    return {
      // Reference to the GridStack instance to access it later
      grid: undefined,
      columns: 12,
      width: 6,
      height: 4,
    };
  },
  watch: {
    items: function (newVal) {
      this.loadData(newVal)
    },
  },
  mounted: function () {
    // Provides access to the GridStack instance across the Vue component.
    // TODO, resize temporary disabled
    this.grid = GridStack.init({ float: false, minRow: 1, disableResize: true, animate: true });

    this.grid.on('change', (event, items) => {
      if (!items) return;
      this.$store.dispatch('_updateWidgetPositions', {
        widgetPositions : items.map(item => {
          return {
            widgetId: item.widgetId,
            x: item.x,
            y: item.y
          }
        })
      });
    });

    // Use an arrow function so that `this` is bound to the Vue instance.
    // this.grid.on("resizestop", (event, element) => {
    //   const node = element.gridstackNode;
    //   //console.log('resized', node)
    //   this.$store.dispatch('_updateWidget', node);
    // });

  },
  methods: {
    async loadData(items) {

      const {
        ensembles,
        user
      } = this.filters

      // console.log('load grid', items)
      this.grid.removeAll();
      // this.grid.load(items); non funziona con componenti vue 
      items.forEach((w) => {

        w = {
          ...w,
          ensembles,
          user
        }

        this.createWidget({
          widget: w
        });
      });
    },

    addWidget(newWidget) {

      const {
        ensembles,
        user
      } = this.filters

      const w = {
        ...newWidget,
        ensembles,
        user
      };

      this.updatePositionAfterAdd();

      this.createWidget({
        widget: w
      });

    },

    createWidget({
      widget
    }) {
      const MyWidget = Vue.extend(Widget);
      let instance = new MyWidget({
        propsData: {
          idTarget: `lineChart${widget.widgetId}`,
          deleteWidget: this.deleteWidget,
          data: widget,
          vuetify: this.$vuetify,
          store: this.$store,
        }
      });

      let div = document.createElement('div');
      div.id = widget.widgetId;
      instance.$mount(div);

      this.grid.addWidget({
        ...widget,
        content: div.outerHTML,
        maxW: this.columns,
        maxH: this.height * 2,
        minW: this.width,
        minH: this.height,
        w: widget.width || this.width,
        h: widget.height || this.height,
      });

      document.getElementById(div.id).appendChild(instance.$el)
    },

    updatePositionAfterAdd() {
      // Ordina i nodi prima di eseguire gli spostamenti
      const sortedNodes = [...this.grid.engine.nodes].sort((a, b) => {
        if (a.y === b.y) {
          return a.x - b.x; // Ordina per colonna se sono sulla stessa riga
        }
        return a.y - b.y; // Altrimenti, ordina per riga
      });

      // Imposta l'offset iniziale
      let offsetX = 6; // Il primo elemento parte da x=6
      let offsetY = 0; // Il primo elemento parte da y=0

      sortedNodes.forEach((w, i) => {
        // Calcola la posizione X (colonna)
        let x = (i * this.width + offsetX) % this.columns;

        // Calcola la posizione Y (riga)
        let y = offsetY + Math.floor((i * this.width + offsetX) / this.columns) * this.height;

        // Aggiorna il widget con la nuova posizione
        this.grid.update(w.el, x, y);

        // Restituisci l'elemento con le coordinate x e y
        return { id: w.widgetId, x, y };
      });
    },

    removeWidget(widgetId) {
      // Trova il widget da rimuovere
      const widgetToRemove = this.grid.engine.nodes.find(w => w.widgetId === widgetId);
      if (!widgetToRemove) return;

      // Ordina i widget per posizione
      const sorted = this.grid.engine.nodes.sort((a, b) => {
        if (a.y === b.y) {
          return a.x - b.x; // Ordina per colonna
        }
        return a.y - b.y; // Ordina per riga
      });

      // Trova la posizione del widget rimosso
      const removedIndex = sorted.indexOf(widgetToRemove);

      // Rimuovi il widget dalla griglia
      this.grid.removeWidget(widgetToRemove.el);

      // Filtra i widget successivi a quello rimosso
      const widgetsAfterRemoved = sorted.filter((w, i) => i > removedIndex);

      // Aggiorna solo i widget successivi
      this.updatePositionsAfterDelete(widgetsAfterRemoved, widgetToRemove);
    },

    updatePositionsAfterDelete(widgetsAfterRemoved, widgetToRemove) {
      // Aggiorna le posizioni solo per i widget successivi
      let x = widgetToRemove.x;
      let y = widgetToRemove.y;


      widgetsAfterRemoved.forEach((w) => {
        // Posiziona il widget nel "buco" del precedente
        this.grid.update(w.el, x, y);

        // Calcola la prossima posizione
        x += this.width;
        if (x >= this.columns) {
          x = 0;
          y += this.height;
        }
      });
    }

  },

}
</script>


<style>
/* required file for gridstack to work */
@import "../../../node_modules/gridstack/dist/gridstack.css";

/* Optional styles for demos */
.btn-primary {
  color: #fff;
  background-color: #007bff;
}

.btn {
  display: inline-block;
  padding: .375rem .75rem;
  line-height: 1.5;
  border-radius: .25rem;
}

a {
  text-decoration: none;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: .5rem;
}

/*
.grid-stack {
  border: 1px solid #dfdfdf;
}
*/

.grid-stack-item-content {
  border: 1px solid #dfdfdf;
  padding: 5px;
  background-color: rgb(243 237 255 / 10%);
  overflow: hidden !important;
}

.grid-stack-item-removing {
  opacity: 0.5;
}

.trash {
  height: 100px;
  background: rgba(255, 0, 0, 0.1) center center url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDQzOC41MjkgNDM4LjUyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDM4LjUyOSA0MzguNTI5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQxNy42ODksNzUuNjU0Yy0xLjcxMS0xLjcwOS0zLjkwMS0yLjU2OC02LjU2My0yLjU2OGgtODguMjI0TDMwMi45MTcsMjUuNDFjLTIuODU0LTcuMDQ0LTcuOTk0LTEzLjA0LTE1LjQxMy0xNy45ODkgICAgQzI4MC4wNzgsMi40NzMsMjcyLjU1NiwwLDI2NC45NDUsMGgtOTEuMzYzYy03LjYxMSwwLTE1LjEzMSwyLjQ3My0yMi41NTQsNy40MjFjLTcuNDI0LDQuOTQ5LTEyLjU2MywxMC45NDQtMTUuNDE5LDE3Ljk4OSAgICBsLTE5Ljk4NSw0Ny42NzZoLTg4LjIyYy0yLjY2NywwLTQuODUzLDAuODU5LTYuNTY3LDIuNTY4Yy0xLjcwOSwxLjcxMy0yLjU2OCwzLjkwMy0yLjU2OCw2LjU2N3YxOC4yNzQgICAgYzAsMi42NjQsMC44NTUsNC44NTQsMi41NjgsNi41NjRjMS43MTQsMS43MTIsMy45MDQsMi41NjgsNi41NjcsMi41NjhoMjcuNDA2djI3MS44YzAsMTUuODAzLDQuNDczLDI5LjI2NiwxMy40MTgsNDAuMzk4ICAgIGM4Ljk0NywxMS4xMzksMTkuNzAxLDE2LjcwMywzMi4yNjQsMTYuNzAzaDIzNy41NDJjMTIuNTY2LDAsMjMuMzE5LTUuNzU2LDMyLjI2NS0xNy4yNjhjOC45NDUtMTEuNTIsMTMuNDE1LTI1LjE3NCwxMy40MTUtNDAuOTcxICAgIFYxMDkuNjI3aDI3LjQxMWMyLjY2MiwwLDQuODUzLTAuODU2LDYuNTYzLTIuNTY4YzEuNzA4LTEuNzA5LDIuNTctMy45LDIuNTctNi41NjRWODIuMjIxICAgIEM0MjAuMjYsNzkuNTU3LDQxOS4zOTcsNzcuMzY3LDQxNy42ODksNzUuNjU0eiBNMTY5LjMwMSwzOS42NzhjMS4zMzEtMS43MTIsMi45NS0yLjc2Miw0Ljg1My0zLjE0aDkwLjUwNCAgICBjMS45MDMsMC4zODEsMy41MjUsMS40Myw0Ljg1NCwzLjE0bDEzLjcwOSwzMy40MDRIMTU1LjMxMUwxNjkuMzAxLDM5LjY3OHogTTM0Ny4xNzMsMzgwLjI5MWMwLDQuMTg2LTAuNjY0LDguMDQyLTEuOTk5LDExLjU2MSAgICBjLTEuMzM0LDMuNTE4LTIuNzE3LDYuMDg4LTQuMTQxLDcuNzA2Yy0xLjQzMSwxLjYyMi0yLjQyMywyLjQyNy0yLjk5OCwyLjQyN0gxMDAuNDkzYy0wLjU3MSwwLTEuNTY1LTAuODA1LTIuOTk2LTIuNDI3ICAgIGMtMS40MjktMS42MTgtMi44MS00LjE4OC00LjE0My03LjcwNmMtMS4zMzEtMy41MTktMS45OTctNy4zNzktMS45OTctMTEuNTYxVjEwOS42MjdoMjU1LjgxNVYzODAuMjkxeiIgZmlsbD0iI2ZmOWNhZSIvPgoJCTxwYXRoIGQ9Ik0xMzcuMDQsMzQ3LjE3MmgxOC4yNzFjMi42NjcsMCw0Ljg1OC0wLjg1NSw2LjU2Ny0yLjU2N2MxLjcwOS0xLjcxOCwyLjU2OC0zLjkwMSwyLjU2OC02LjU3VjE3My41ODEgICAgYzAtMi42NjMtMC44NTktNC44NTMtMi41NjgtNi41NjdjLTEuNzE0LTEuNzA5LTMuODk5LTIuNTY1LTYuNTY3LTIuNTY1SDEzNy4wNGMtMi42NjcsMC00Ljg1NCwwLjg1NS02LjU2NywyLjU2NSAgICBjLTEuNzExLDEuNzE0LTIuNTY4LDMuOTA0LTIuNTY4LDYuNTY3djE2NC40NTRjMCwyLjY2OSwwLjg1NCw0Ljg1MywyLjU2OCw2LjU3QzEzMi4xODYsMzQ2LjMxNiwxMzQuMzczLDM0Ny4xNzIsMTM3LjA0LDM0Ny4xNzJ6IiBmaWxsPSIjZmY5Y2FlIi8+CgkJPHBhdGggZD0iTTIxMC4xMjksMzQ3LjE3MmgxOC4yNzFjMi42NjYsMCw0Ljg1Ni0wLjg1NSw2LjU2NC0yLjU2N2MxLjcxOC0xLjcxOCwyLjU2OS0zLjkwMSwyLjU2OS02LjU3VjE3My41ODEgICAgYzAtMi42NjMtMC44NTItNC44NTMtMi41NjktNi41NjdjLTEuNzA4LTEuNzA5LTMuODk4LTIuNTY1LTYuNTY0LTIuNTY1aC0xOC4yNzFjLTIuNjY0LDAtNC44NTQsMC44NTUtNi41NjcsMi41NjUgICAgYy0xLjcxNCwxLjcxNC0yLjU2OCwzLjkwNC0yLjU2OCw2LjU2N3YxNjQuNDU0YzAsMi42NjksMC44NTQsNC44NTMsMi41NjgsNi41N0MyMDUuMjc0LDM0Ni4zMTYsMjA3LjQ2NSwzNDcuMTcyLDIxMC4xMjksMzQ3LjE3MnogICAgIiBmaWxsPSIjZmY5Y2FlIi8+CgkJPHBhdGggZD0iTTI4My4yMiwzNDcuMTcyaDE4LjI2OGMyLjY2OSwwLDQuODU5LTAuODU1LDYuNTctMi41NjdjMS43MTEtMS43MTgsMi41NjItMy45MDEsMi41NjItNi41N1YxNzMuNTgxICAgIGMwLTIuNjYzLTAuODUyLTQuODUzLTIuNTYyLTYuNTY3Yy0xLjcxMS0xLjcwOS0zLjkwMS0yLjU2NS02LjU3LTIuNTY1SDI4My4yMmMtMi42NywwLTQuODUzLDAuODU1LTYuNTcxLDIuNTY1ICAgIGMtMS43MTEsMS43MTQtMi41NjYsMy45MDQtMi41NjYsNi41Njd2MTY0LjQ1NGMwLDIuNjY5LDAuODU1LDQuODUzLDIuNTY2LDYuNTdDMjc4LjM2NywzNDYuMzE2LDI4MC41NSwzNDcuMTcyLDI4My4yMiwzNDcuMTcyeiIgZmlsbD0iI2ZmOWNhZSIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=) no-repeat;
}

.sidebar {
  background: rgba(0, 255, 0, 0.1);
  padding: 25px 0;
  height: 100px;
  text-align: center;
}

.sidebar .grid-stack-item {
  width: 120px;
  height: 50px;
  border: 2px dashed green;
  text-align: center;
  line-height: 35px;
  z-index: 10;
  background: rgba(0, 255, 0, 0.1);
  cursor: default;
  display: inline-block;
}

.sidebar .grid-stack-item .grid-stack-item-content {
  background: none;
}
</style>
